import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer } from 'rxjs';
import { ASSET_NAME } from 'src/app/app.consts';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { handleApiError } from 'src/app/utils/error';
import { FlowService } from 'src/app/services/flow.service';
import { take } from 'rxjs/operators';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'app-other-securities',
  templateUrl: './other-securities.component.html',
  styleUrls: ['./other-securities.component.scss'],
})
export class OtherSecuritiesComponent implements OnInit, OnDestroy {
  applicationId!: number;
  otherSecuritiesForm!: FormGroup;
  error!: string;
  assetName!: typeof ASSET_NAME;
  subs: Array<Subscription> = [];
  requestPending = false;
  @Input() isSummary!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private applicationService: ApplicationService,
    private applicationsApiService: ApplicationsApiService,
    public flowService: FlowService,
    protected trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.applicationService.applicationId;

    const initialOther = this.applicationService.other || '';
    const initialOtherSecuritiesFiles =
      this.applicationService.otherSecuritiesFiles || [];

    this.otherSecuritiesForm = this.formBuilder.group({
      other: this.formBuilder.control(initialOther),
      otherSecuritiesFiles: this.formBuilder.array(initialOtherSecuritiesFiles),
    });
    this.assetName = ASSET_NAME;
  }

  otherSecuritiesDescriptionUpdate(): void {
    this.requestPending = true;
    const securitiesDescription = this.other.value;
    this.applicationService.other = securitiesDescription;
    this.subs.push(
      this.applicationsApiService
        .addSecurity({
          other: securitiesDescription,
          applicationId: this.applicationId,
        })
        .pipe(take(1))
        .subscribe(
          () => {
            this.error = '';
            this.trackFields('otherSecuritiesDesc');
          },
          (error: any) => handleApiError(error, this.translateService),
          () => (this.requestPending = false)
        )
    );
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }

  handleBackButtonClick(): void {
    this.subs.push(
      timer(1000, 1000).subscribe(() => {
        if (!this.requestPending) {
          this.flowService.previousScreen();
        }
      })
    );
  }

  handleNextButtonClick(): void {
    this.subs.push(
      timer(1000, 1000).subscribe(() => {
        if (!this.requestPending) {
          this.flowService.nextScreen();
        }
      })
    );
  }

  get form(): FormGroup {
    return this.otherSecuritiesForm;
  }

  get other(): FormControl {
    return this.form.get('other') as FormControl;
  }

  get otherSecuritiesFiles(): FormArray {
    return this.form.get('otherSecuritiesFiles') as FormArray;
  }
}
